import {Injectable} from '@angular/core';
import {MitgliederDomainDto} from '@wba/models/dto/mitglieder-domain-dto';
import {MitgliedService} from '@wba/services/api/mitglied/mitglied.service';
import {RequestBodyEinkommen} from '@wba/services/api/mitglied/request-body-einkommen.interface';
import {Observable, of} from 'rxjs';

@Injectable()
export class MitgliedMockService implements MitgliedService {
  deleteEinkommen(ids: number[], antragId): Observable<any> {
    return of();
  }

  deleteMitglied(mitgliedId, antragId): Observable<any> {
    return of();
  }

  getEinkommenByMitglied(antragId: string): Observable<RequestBodyEinkommen> {
    return of({
      einkommen: []
    });
  }

  getMitglieder(antragId: string): Observable<MitgliederDomainDto> {
    return of({
      mitglieder: [{
        id: '5b1709fa-ae91-4940-bc19-758a41d6cfa0',
        vorname: 'Karl',
        nachname: 'Gerdes',
        isAntragsteller: true,
        beziehtEinkommen: null,
        wechseltFamilienstand: false,
        wechseltFamilienstandDatum: null,
        familienstandArtAenderung: null,
        auszugEinzug: 'WOHNHAFT',
        auszugEinzugDatum: null,
        geburtsdatum: '1958-02-01',
        geschlecht: 'M',
        iban: null,
        keinKonto: false,
        kontoHinweise: null
      }],
      bg: {
        hatKostenUnterkunft: false,
        hatUmzug: false,
        letzteBewilligung: '2021-03-02'
      }
    });
  }

  getMitgliederFuerAnlageEk(antragId: string): Observable<{ id: string; name: string }[]> {
    return of();
  }

  updateEinkommen(einkommen, antragId): Observable<any> {
    return of();
  }

  updateMitglieder(mitglied, antragId, withCleanup = true): Observable<any> {
    return of();
  }

  updateNachweise(antragId, mitglieder: { mitgliedId: string; nachweisId: string }[]): Observable<any> {
    return of();
  }
}
